import { render, staticRenderFns } from "./BvaAnalytics.vue?vue&type=template&id=43c81d3e&scoped=true&"
import script from "./BvaAnalytics.vue?vue&type=script&lang=ts&"
export * from "./BvaAnalytics.vue?vue&type=script&lang=ts&"
import style0 from "./BvaAnalytics.vue?vue&type=style&index=0&id=43c81d3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c81d3e",
  null
  
)

export default component.exports